
import { Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectIsCardHoldTimesBannerEnabled,
  selectIsCardTelephonyOutageBannerEnabled,
  selectIsLoanHoldTimesBannerEnabled,
  selectIsLoanTelephonyOutageBannerEnabled,
  selectIsTelephonyOutageBannerEnabled,
} from '../../../../store/selectors/feature-flag.selector';

@Component({
  selector: 'app-service-alert-banner',
  standalone: true,
  imports: [],
  templateUrl: './service-alert-banner.component.html',
})
export class ServiceAlertBannerComponent {
  private readonly store = inject(Store);

  readonly isTelephonyOutageEnabled = this.store.selectSignal(selectIsTelephonyOutageBannerEnabled);
  readonly isCardHoldTimesEnabled = this.store.selectSignal(selectIsCardHoldTimesBannerEnabled);
  readonly isLoanHoldTimesEnabled = this.store.selectSignal(selectIsLoanHoldTimesBannerEnabled);
  readonly isLoanTelephonyOutageEnabled = this.store.selectSignal(selectIsLoanTelephonyOutageBannerEnabled);
  readonly isCardTelephonyOutageEnabled = this.store.selectSignal(selectIsCardTelephonyOutageBannerEnabled);

  readonly alertType = computed(() => {
    if (this.isTelephonyOutageEnabled()) {
      return 'telephony-outage';
    }

    if (this.isCardHoldTimesEnabled()) {
      return 'card-hold-times';
    }

    if (this.isLoanHoldTimesEnabled()) {
      return 'loan-hold-times';
    }

    if (this.isLoanTelephonyOutageEnabled()) {
      return 'loan-telephony-outage';
    }

    if (this.isCardTelephonyOutageEnabled()) {
      return 'card-telephony-outage';
    }

    return null;
  });

  readonly hasVisibleAlerts = computed(() => this.alertType() !== null);
}
